export const translations = {
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  novoBtn: {
    pt: "Novo Fornecedor",
    en: "New Supplier",
    de: "Neuer Lieferant",
    es: "Nuevo Proveedor",
  },
};
